<div class="grid-container">
  <div class="grid-item">
    <app-mdm-input *ngIf="unspscCodesLoaded" outsideLabel="UNSPSC Category"
                   [selectLimit]="5"
                   [dropDownSelect]="true"
                   [dropDownData]="unspscCodes"
                   [(chips)]="selectedUnspscCodes"
                   [singleSelect]="false"
                   searchPlaceholderText="UNSPSC code"
                   [maxChipTextLength]="45">
    </app-mdm-input>
    <span *ngIf="!unspscCodesLoaded">UNSPSC codes Loading...</span>
  </div>
</div>
<span class="parameterbuttons">
  <button class="clearparameterbutton" [disabled]="disableSearch()" mat-raised-button color="primary" (click)="clearParameters()">Clear Parameters</button>
  <button [disabled]="disableSearch()" mat-raised-button color="primary" (click)="searchClick()">Search</button>
</span>
